import { atom } from 'recoil'
import { API } from '../api/helpers'
import { errorResponse } from '../helper/getErrorResponse'

export const dataOrderState = atom({
  key: 'dataOrderState',
  default: { rows: [], meta: {} },
})

export const dataHistoryOrderState = atom({
  key: 'dataHistoryOrderState',
  default: { data: [], meta: {} },
})

export const dataOrderShowOneState = atom({
  key: 'dataOrderShowOneState',
  default: {},
})

export const fetchDataOrderPagination = async (params, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.get(`orders?${params}`)
    if (data.status) {
      cb(data.data)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const fetchDataOrder = async (orderId, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.get(`orders/${orderId}`)
    if (data.status) {
      cb(data)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const addItemOrder = async (orderId, input, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`orders/batch-add/${orderId}`, input)
    if (data.status) {
      cb(data.message, null)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const updateItemOrder = async (orderId, itemId, input, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.patch(`orders/${orderId}/${itemId}`, input)
    if (data.status) {
      cb(data.message, null)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const deleteItemOrder = async (orderId, itemId, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.delete(`orders/${orderId}/${itemId}`)
    if (data.status) {
      cb(data.message, null)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const deleteItemExternalOrder = async (orderId, itemId, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.delete(`external-order/${orderId}/${itemId}`)
    if (data.status) {
      cb(data.message, null)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const editItemExternalOrder = async (orderId, itemId, body, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.patch(`external-order/update-qty/${orderId}/${itemId}`, body)
    if (data.status) {
      cb(data.message, null)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const editItemOrder = async (orderId, itemId, body, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.patch(`orders/update-qty/${orderId}/${itemId}`, body)
    if (data.status) {
      cb(data.message, null)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const publishOrder = async (orderId, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`orders/publish/${orderId}`)
    if (data.status) {
      cb(data.message, null)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const submitBilling = async (orderId, payload, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`billing/order/${orderId}`, payload)
    if (data.status) {
      cb(data.message, null)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const cancelBilling = async (orderId, payload, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`billing/order/${orderId}/cancel`, payload)
    if (data.status) {
      cb(data.message, null)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

// attach voucher
export const attachVoucherOrder = async (input, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`orders/voucher/attach`, input)
    if (data) {
      cb(data)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

// detach voucher
export const detachVoucherOrder = async (input, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`orders/voucher/detach`, input)
    if (data) {
      cb(data)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const fetchHistoryOrder = async (id, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.get(`orders/history/${id}`)
    if (data) {
      cb(data)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const makeRevision = async (orderId, payload, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`orders/create-revision/${orderId}`, payload)
    if (data.status) {
      cb(data.message, null)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const setDoctorOrder = async (id, payload, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.patch(`orders/set-doctor/${id}`, payload)
    if (data.status) {
      cb(data.data)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const addItemDoctorOrderService = async (payload, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`doctor-order-service/create`, payload)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const fetchItemDoctorOrderServiceByRegno = async (regno, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.get(`doctor-order-service/show-by-regno/${regno}`)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}
export const fetchItemDoctorOrderServiceById = async (id, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.get(`doctor-order-service/show/${id}`)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const deleteItemDoctorOrderService = async (headerId, itemId, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.delete(`doctor-order-service/delete-item/${headerId}/${itemId}`)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const dischargeItemDoctorOrderService = async (headerId, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.patch(`doctor-order-service/discharge/${headerId}`)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}
export const undischargeItemDoctorOrderService = async (headerId, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.patch(`doctor-order-service/undischarge/${headerId}`)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const fetchDataDoctorOrderServicePagination = async (params, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.get(`doctor-order-service?${params}`)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const requestRevisionDoctorOrderService = async (payload, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`doctor-order-service/request-revision`, payload)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const confirmOrderDoctorOrderService = async (id, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`doctor-order-service/confirm/${id}`)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const checkRevisionByRegno = async (regno, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.get(`orders/check-revision/is-revision-by-regno/${regno}`)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const fetchItemDoctorOrderMedicationByRegno = async (regno, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.get(`fmtforms/medication/get-by-regno/${regno}`)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const deleteFmtMedication = async (id, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.delete(`fmtforms/medication/${id}`)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const createRequestAccessOrder = async (payload, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`req-access/req-code`, payload)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}
export const verifyRequestAccessOrder = async (payload, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.post(`req-access/verify-code`, payload)
    cb(data, null)
  } catch (error) {
    errorResponse(error, cb)
  }
}

export const fetchPackageInformation = async (orderId, branch, cb) => {
  try {
    const { request } = API(true)
    const { data } = await request.get(`orders/package-info/${orderId}/${branch}`)
    if (data.status) {
      cb(data.data)
    }
  } catch (error) {
    errorResponse(error, cb)
  }
}
